import { cn } from "@/lib/cn";

/** A stream platform's square mark (lib/stream-platforms.ts), as a round chip. */
export function PlatformLogo({ logo, size = 30, className }: { logo: string; size?: number; className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- tiny static marks from /public/platforms
    <img src={logo} alt="" width={size} height={size} className={cn("shrink-0 rounded-full object-cover", className)} style={{ width: size, height: size }} />
  );
}
